<form #removeForm="ngForm" (ngSubmit)="remove()" novalidate>
  <h2 mat-dialog-title>Archiving Pair</h2>
  <mat-dialog-content>
    <div class="pairs">
      <div class="row" *ngIf="pair.recipient">
        <span class="label">Recipient:</span>
        <span class="value">{{ pair.recipient!.enisNumber }}</span>
        <span class="flex">{{ pair.recipient.firstName || "" }}</span>
      </div>
      <div class="row">
        <span class="label">{{ pair.recipient ? "Donor" : "Altruist" }}:</span>
        <span class="value">{{ pair.donor.enisNumber }}</span>
        <span class="flex">{{ pair.donor.firstName || "" }}</span>
      </div>
    </div>

    <ng-container>
      <mat-form-field>
        <mat-select placeholder="Reason for archiving" [(ngModel)]="selectedReason" required name="selectedReason">
          <mat-option *ngFor="let reason of reasons$" [value]="reason" [class.transplanted-reason]="isTransplantedReason(reason)">
            {{ reason }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="otherReasonSelected()">
        <input matInput name="otherReason" type="text" required placeholder="Reason for removing the pair" [(ngModel)]="otherReason" #reasonCtrl="ngModel" />
        <mat-error *ngIf="reasonCtrl.hasError('required')"> Please enter a reason for removing the pair. </mat-error>
      </mat-form-field>
    </ng-container>
    <ng-template #willRemove>
      <i>Are you sure you want to remove this pair?</i>
    </ng-template>
  </mat-dialog-content>
  <mat-dialog-actions class="actions">
    <div class="spacer"></div>
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button type="submit" [disabled]="!removeForm.valid">Remove</button>
  </mat-dialog-actions>
</form>
